/**
 * Single home for how a product category is coloured on screen.
 *
 * Colour is chosen by a person on the category card (ProductCategoryTag.color,
 * #rrggbb); there is no automatic colour (owner decision 2026-09-24). A
 * category without one is shown as a neutral tag.
 */

// Choices offered on the category card: distinct hues first, greys last.
export const CATEGORY_COLOR_PRESETS = [
  '#1677ff', '#2f54eb', '#722ed1', '#c41d7f', '#eb2f96',
  '#f5222d', '#a8071a', '#fa541c', '#fa8c16', '#d48806',
  '#faad14', '#a0d911', '#52c41a', '#237804', '#13c2c2',
  '#08979c', '#006d75', '#874d00', '#595959', '#8c8c8c',
];

const HEX_COLOR = /^#[0-9a-f]{6}$/i;

/** The category's own colour when it is a valid #rrggbb, otherwise null (neutral tag). */
export function categoryDisplayColor(color?: string | null): string | null {
  return color && HEX_COLOR.test(color) ? color : null;
}
